import Announcement from "./Announcement";

export default Announcement;
